import { Controller } from "@hotwired/stimulus"
import BSN from "bootstrap.native/dist/bootstrap-native-v4-esm.min.js"


export default class extends Controller {
  static values = {
    selector: String
  }

  connect() { BSN.initCallback(this.hasSelectorValue ? document.querySelector(this.selectorValue) : document.body) }
}
